"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EEtatCompteTrads = void 0;
exports.EEtatCompteTrads = {
    actif: "Actif",
    inactif: "Inactif",
};
